import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from 'dash-ui';
import Background from 'assets/images/jpg/SignInPageMask.jpg';
import LogoImg from 'assets/images/png/SignInLogo.png';
import Footer from 'flow-components/Footer/Footer';

const LeftPanel = styled(Flex)`
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 764px;
  height: calc(100vh - 56px);
  display: flex;
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;
const RightPanel = styled(Flex)`
  height: calc(100vh - 56px);
  @media ${({ theme }) => theme.devices.mobile} {
    height: calc(100vh - 160px);
    padding: ${({ theme }) => theme.space * 5.5}px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    height: calc(100vh - 112px);
  }
  overflow-y: scroll;
`;

function AuthenticationPageLayout({ children }: { children: ReactNode }) {
  return (
    <Flex
      flex={1}
      flexDirection="column"
      alignItems="inherit"
      minHeight="100vh"
    >
      <Flex flex={1} flexDirection="row">
        <LeftPanel justifyContent="center" alignItems="center" flex={1}>
          <img src={LogoImg} alt="Dash Logo" />
        </LeftPanel>
        <RightPanel flex={1} justifyContent="center" alignItems="center">
          {children}
        </RightPanel>
      </Flex>
      <Footer variation="dark" withSidebar={false} />
    </Flex>
  );
}

export default AuthenticationPageLayout;
